module.exports = __webpack_public_path__ + "static/media/location-pin.2811e8c1.svg";